module.exports = __webpack_public_path__ + "img/Miami World Center.64295f7c.png";